import { render, staticRenderFns } from "./CartNew.vue?vue&type=template&id=1f9681f8"
import script from "./CartNew.vue?vue&type=script&lang=js"
export * from "./CartNew.vue?vue&type=script&lang=js"
import style0 from "./CartNew.vue?vue&type=style&index=0&id=1f9681f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports